import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { productImage } from "../../lib/api";

export default function BoxGallery({ images = [], captions = [], name }) {
  const [i, setI] = useState(0);
  if (!images.length) return null;
  const go = (d) => setI((v) => (v + d + images.length) % images.length);
  return (
    <div data-testid="box-gallery">
      <div className="relative bg-slate-50 border border-slate-200 aspect-square overflow-hidden group">
        <img
          key={i}
          src={productImage(images[i])}
          alt={captions[i] || name}
          className="w-full h-full object-cover animate-in fade-in duration-300"
          data-testid="box-gallery-main"
        />
        {images.length > 1 && (
          <>
            <button type="button" onClick={() => go(-1)} aria-label="Previous image" data-testid="box-gallery-prev"
              className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 grid place-items-center bg-white/90 border border-slate-200 text-kolt-slate hover:bg-kolt-slate hover:text-white transition-colors">
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button type="button" onClick={() => go(1)} aria-label="Next image" data-testid="box-gallery-next"
              className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 grid place-items-center bg-white/90 border border-slate-200 text-kolt-slate hover:bg-kolt-slate hover:text-white transition-colors">
              <ChevronRight className="w-5 h-5" />
            </button>
          </>
        )}
        {captions[i] && (
          <div className="absolute bottom-0 left-0 right-0 bg-kolt-slate-dark/85 text-white text-xs font-mono tracking-wider px-4 py-2" data-testid="box-gallery-caption">
            {captions[i]}
          </div>
        )}
      </div>
      <div className="mt-3 grid grid-cols-5 gap-2">
        {images.map((src, k) => (
          <button key={src} type="button" onClick={() => setI(k)} data-testid={`box-gallery-thumb-${k}`}
            className={`aspect-square overflow-hidden border-2 transition-colors ${k === i ? "border-kolt-orange" : "border-slate-200 hover:border-slate-400"}`}>
            <img src={productImage(src)} alt="" className="w-full h-full object-cover" loading="lazy" />
          </button>
        ))}
      </div>
    </div>
  );
}
